<template>
<v-app>
    <v-content>
        <v-card>

            <v-toolbar color="blue lighten-1" dark tabs>
                <v-btn icon flat @click="goBack()">
                    <v-icon>arrow_back</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                # {{$route.params.id}}
                <v-tabs slot="extension" v-model="tab" color="blue lighten-1" fixed-tabs>
                    <v-tabs-slider color="yellow"></v-tabs-slider>
                    <v-tab v-for="item in items" :key="item.id">
                        {{ item.text }}
                    </v-tab>
                </v-tabs>
            </v-toolbar>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="item in items" :key="item.id">
                    <ContractorsCardMainTab :title="item.text" :id="Number($route.params.id)" v-if="item.id == 0" />
                    <ContractorsCardContactsTab :title="item.text" :id="Number($route.params.id)" v-if="item.id == 1" />
                    <ContractorsCardAddressesTab :title="item.text" :id="Number($route.params.id)" v-if="item.id == 2" />
                    <ContractorsCardCommentsTab :title="item.text" :id="Number($route.params.id)" v-if="item.id == 3" />
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-content>

</v-app>
</template>

<script>
import {
    HTTP
} from '../http-common'

import ContractorsCardMainTab from './ContractorsCardMainTab.vue'
import ContractorsCardContactsTab from './ContractorsCardContactsTab.vue'
import ContractorsCardAddressesTab from './ContractorsCardAddressesTab.vue'
import ContractorsCardCommentsTab from './ContractorsCardCommentsTab.vue'

export default {
    components: {
        ContractorsCardMainTab,
        ContractorsCardContactsTab,
        ContractorsCardAddressesTab,
        ContractorsCardCommentsTab
    },
    data: () => ({
        tab: null,
        items: [{
                text: 'Загальні відомості',
                id: 0
            },
            {
                text: 'Контакти СЦ',
                id: 1
            },
            {
                text: 'Адреси СЦ',
                id: 2
            },
            {
                text: 'Історія роботи',
                id: 3
            },
        ],
    }),
    props: {},
    methods: {
        goBack() {
            window.history.state ? this.$router.go(-1) : this.$router.push('/')
        }
    },
 
}
</script>
